import React from 'react';
import { connect } from 'react-redux';
import ToggleCell from '@/components/table/ToggleCell';
import {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/DictionaryFieldContainer';

const DictionaryFieldCohortFilterTableCell = ({
  code,
  category,
  cohortFilter,
  dictionaryUUID,
  fieldUUID,
  fieldName,
  canEdit,
  template,
  updateProperties,
}) => (
  <ToggleCell
    checked={cohortFilter}
    disabled={!canEdit}
    label={fieldName}
    onClick={() => (
      updateProperties(category, code, dictionaryUUID, { cohort_filter: !cohortFilter }, fieldUUID, template)
    )}
  />
);

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldCohortFilterTableCell);
